import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Slider from "react-slick";
import { IoIosCloseCircleOutline } from "react-icons/io";
import { fetchNewsData } from "../../redux/slicer/gallerySlice";

import NewsDetails from "./news_details";
import parse from "html-react-parser";

import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

function GalleryNews() {
  const dispatch = useDispatch();
  const {
    data: newsData = [],
    loading,
    error,
  } = useSelector((state) => state.gallery.news);

  useEffect(() => {
    dispatch(fetchNewsData());
  }, [dispatch]);

  const [isOpenEdit, setIsOpenEdit] = useState(false);
  const [selectedCard, setSelectedCard] = useState(null);

  const openEditPopup = (card) => {
    setSelectedCard(card);
    setIsOpenEdit(true);
  };

  const closeEditPopup = () => {
    setSelectedCard(null);
    setIsOpenEdit(false);
  };

  // Slider settings for the carousel
  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
  };

  // Function to format date
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = date.getDate();
    const month = date.toLocaleString("default", { month: "short" });

    const ordinal = (n) => {
      const s = ["th", "st", "nd", "rd"];
      const v = n % 100;
      return n + (s[(v - 20) % 10] || s[v] || s[0]);
    };

    return `${ordinal(day)} ${month}`;
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  return (
    <div className="container mx-auto p-4">
      {/* Cards Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {newsData.map((card) => (
          <div
            key={card.id}
           className="rounded shadow-lg bg-white w-xs  h-auto flex flex-col relative"
          >
            {/* Image Carousel or Single Image */}
            <div className="h-full w-full overflow-hidden">
              {card.images.length > 1 ? (
                <Slider {...sliderSettings}>
                  {card.images.map((image, index) => (
                    <div key={index}>
                      <img
                         className="w-[450px] h-[300px] object-cover rounded-t-lg"
                        src={image}
                        alt={`Slide ${index + 1}`}
                      />
                    </div>
                  ))}
                </Slider>
              ) : (
                <div>
                  <img
                    className="w-full h-full object-cover"
                    src={card.images[0]}
                    alt="Single Image"
                  />
                </div>
              )}
            </div>

            {/* Date Badge */}
            <div className="bg-[#AC39FF] h-9 w-[100px] rounded-lg absolute top-4 left-4 flex items-center justify-center">
              <p className="text-white text-sm font-semibold font-inter">
                {formatDate(card.date)}
              </p>
            </div>

            <div className="px-4 py-4 flex flex-col justify-between flex-1">
              <div className="font-bold text-primary-color text-justify mb-2 font-titillium">
                {card.title}
              </div>
              {/* Truncated Description */}
              <p
                className="text-black text-base text-justify line-clamp-3 font-inter"
                style={{
                  display: "-webkit-box",
                  WebkitLineClamp: 3,
                  WebkitBoxOrient: "vertical",
                  overflow: "hidden",
                }}
              >
                {parse(card.description)}
              </p>

              {/* Read More Button */}
              <div className="mt-auto pt-2">
                <button
                  onClick={() => openEditPopup(card)}
                  className="flex items-center justify-center text-primary-color hover:underline"
                >
                  Read More
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Modal for Card Details */}
      {isOpenEdit && selectedCard && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-gray-800 bg-opacity-50">
          <div className="bg-white p-6 rounded-lg relative max-w-lg w-full">
            <button
              type="button"
              onClick={closeEditPopup}
              className="absolute text-4xl top-4 right-4 text-gray-500 hover:text-black"
            >
              <IoIosCloseCircleOutline />
            </button>
            <NewsDetails card={selectedCard} onClose={closeEditPopup} />
          </div>
        </div>
      )}
    </div>
  );
}

export default GalleryNews;
